import {Component, Inject} from '@angular/core';
import {Localization} from "../../../../common/enums/localization";
import {UntypedFormControl, Validators} from "@angular/forms";
import {InterventionTeamResource} from "../../intervention-team.resource";
import {InterventionTeamDetailDto} from "../intervention-team-detail.dto";
import {trackLoadingOn} from "../../../../../angular/component/loading/loads-data";
import {map, tap} from "rxjs/operators";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-edit-name-dialog',
  templateUrl: './edit-name-dialog.component.html',
  styleUrls: ['./edit-name-dialog.component.scss']
})
export class EditNameDialogComponent {
  public saving = false;
  public readonly Localization = Localization;

  public readonly nameField = new UntypedFormControl(this.data?.team.label, [Validators.required])

  constructor(
    private readonly self: MatDialogRef<EditNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    private readonly data: EditNameData,
    private readonly teamResource: InterventionTeamResource,
  ) {
  }

  public get isEditing(): boolean {
    return !!this.data?.team?.id;
  }

  public get canSave(): boolean {
    return this.nameField.valid && this.nameField.dirty;
  }

  public cancel(): void {
    this.self.close();
  }

  public save() {
    let team = {...this.data?.team, label: this.nameField.value} as InterventionTeamDetailDto;
    const persistOperation = this.isEditing ?
      this.teamResource.update(team) : this.teamResource.create(team).pipe(tap(dto => team = dto));
    const updateTeamRequest = trackLoadingOn(persistOperation, this, 'saving');
    updateTeamRequest.subscribe((persistedTeam) => this.self.close(persistedTeam));
  }
}

export interface EditNameData {
  team: InterventionTeamDetailDto;
}
